import React, { Fragment } from 'react';

import MediaMdUp from 'components/Responsive/MediaMdUp';
import MediaSmDown from 'components/Responsive/MediaSmDown';
import ProfileMdUp from './ProfileMdUp';
import ProfileSmDown from './ProfileSmDown';

export default function ProfileComponent(props) {
  return (
    <Fragment>
      <MediaMdUp>
        <ProfileMdUp {...props} />
      </MediaMdUp>
      <MediaSmDown>
        <ProfileSmDown {...props} />
      </MediaSmDown>
    </Fragment>
  );
}